import { render, staticRenderFns } from "./ScoringParameters.vue?vue&type=template&id=4d9ca4f4&"
import script from "./ScoringParameters.vue?vue&type=script&lang=js&"
export * from "./ScoringParameters.vue?vue&type=script&lang=js&"
import style0 from "./ScoringParameters.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCard,VCardText,VDataTable,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9ca4f4')) {
      api.createRecord('4d9ca4f4', component.options)
    } else {
      api.reload('4d9ca4f4', component.options)
    }
    module.hot.accept("./ScoringParameters.vue?vue&type=template&id=4d9ca4f4&", function () {
      api.rerender('4d9ca4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sumar/ScoringParameters.vue"
export default component.exports